import type { FC } from 'react'

import { Show } from 'common/components/Show/Show'
import { UtilService } from 'common/services/utilService'

import { CartCollapse } from 'features/Cart/components/CartCollapse/CartCollapse'
import type { IOptionShopCartDay } from 'features/Option'

import styles from './cartShopItem.module.scss'

interface IProps {
  day: IOptionShopCartDay
  optionId: number
  handleRemoveSlot: (roomId: number, slotId: number, day?: string) => void
}

export const CartShopDay: FC<IProps> = ({ day, optionId, handleRemoveSlot }) => {
  return (
    <CartCollapse
      title={day?.title}
      handleRemoveSlot={() => handleRemoveSlot(optionId, null, day?.date)}
      error={day?.error_message}
      additionalActiveTitle={day?.title}>
      <Show when={day?.price}>
        <div className={styles.parent}>
          {day?.title}
          <span>{UtilService.numberToDollar(day?.price)}</span>
        </div>
      </Show>
    </CartCollapse>
  )
}
